import {
  ButtonWrapper,
  CardButtonMedium,
  DividerHorizontal,
  Section,
  Skeleton,
} from '@ferreri/prever-component-lib';
import { useRouter } from 'next/router';
import { useQueryClient } from '@ferreri/minato-react-utils';

import {
  useGeocodeCombinedCurrentGeolocation,
  usePersistedGeolocation,
} from '@modules/geolocation/geolocation.store';
import useNavigatorPermissions from '@utils/useNavigatorPermissions';

export const CurrentGeoLocationCardButton = () => {
  const router = useRouter();
  const queryClient = useQueryClient();
  const { permission, error } = useNavigatorPermissions('geolocation');
  const { setValue } = usePersistedGeolocation();
  const { data: geolocationWithAddress, isLoading } =
    useGeocodeCombinedCurrentGeolocation();
  const address = geolocationWithAddress.results?.[0]?.formatted_address;
  const isPermissionDenied = permission === 'denied';

  if (error) {
    console.log({
      error: {
        message: 'Navigator permissions error',
        code: 'NavigatorPermissionsError',
        status_code: null,
        details: { permission, error },
      },
    });
  }

  if (isPermissionDenied) return null;

  if (isLoading) {
    return (
      <Section>
        <Skeleton height={90} />
        <DividerHorizontal />
      </Section>
    );
  }

  return (
    <Section>
      <ButtonWrapper
        onClick={() => {
          setValue({
            latitude: geolocationWithAddress.latitude,
            longitude: geolocationWithAddress.longitude,
            address,
          });

          queryClient.invalidateQueries({
            queryKey: ['establishmentsIds'],
            exact: false,
          });

          router.push('/');
        }}
      >
        <CardButtonMedium
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M11.25 21.45V20.4692C9.16669 20.2551 7.41284 19.4359 5.98847 18.0115C4.56412 16.5872 3.7449 14.8333 3.5308 12.75H2.55002C2.33752 12.75 2.15941 12.6781 2.01567 12.5343C1.87192 12.3905 1.80005 12.2123 1.80005 11.9997C1.80005 11.7871 1.87192 11.609 2.01567 11.4654C2.15942 11.3218 2.33754 11.25 2.55002 11.25H3.5308C3.7449 9.16669 4.56412 7.41284 5.98847 5.98847C7.41284 4.56412 9.16669 3.7449 11.25 3.5308V2.55002C11.25 2.33754 11.3219 2.15942 11.4657 2.01567C11.6095 1.87192 11.7877 1.80005 12.0003 1.80005C12.2129 1.80005 12.391 1.87192 12.5346 2.01567C12.6782 2.15942 12.75 2.33754 12.75 2.55002V3.5308C14.8333 3.7449 16.5872 4.56412 18.0115 5.98847C19.4359 7.41284 20.2551 9.16669 20.4692 11.25H21.45C21.6625 11.25 21.8406 11.3219 21.9843 11.4657C22.1281 11.6095 22.1999 11.7877 22.1999 12.0003C22.1999 12.2129 22.1281 12.391 21.9843 12.5346C21.8406 12.6782 21.6625 12.75 21.45 12.75H20.4692C20.2551 14.8333 19.4359 16.5872 18.0115 18.0115C16.5872 19.4359 14.8333 20.2551 12.75 20.4692V21.45C12.75 21.6625 12.6781 21.8406 12.5343 21.9843C12.3905 22.1281 12.2123 22.1999 11.9997 22.1999C11.7871 22.1999 11.609 22.1281 11.4654 21.9843C11.3218 21.8406 11.25 21.6625 11.25 21.45ZM12 19C13.9333 19 15.5833 18.3167 16.95 16.95C18.3167 15.5833 19 13.9333 19 12C19 10.0667 18.3167 8.41667 16.95 7.05C15.5833 5.68333 13.9333 5 12 5C10.0667 5 8.41667 5.68333 7.05 7.05C5.68333 8.41667 5 10.0667 5 12C5 13.9333 5.68333 15.5833 7.05 16.95C8.41667 18.3167 10.0667 19 12 19ZM12 15.5C11.0375 15.5 10.2136 15.1573 9.52815 14.4718C8.84273 13.7864 8.50002 12.9625 8.50002 12C8.50002 11.0375 8.84273 10.2136 9.52815 9.52815C10.2136 8.84273 11.0375 8.50002 12 8.50002C12.9625 8.50002 13.7864 8.84273 14.4719 9.52815C15.1573 10.2136 15.5 11.0375 15.5 12C15.5 12.9625 15.1573 13.7864 14.4719 14.4718C13.7864 15.1573 12.9625 15.5 12 15.5ZM12 14C12.55 14 13.0208 13.8042 13.4125 13.4125C13.8042 13.0208 14 12.55 14 12C14 11.45 13.8042 10.9792 13.4125 10.5875C13.0208 10.1958 12.55 10 12 10C11.45 10 10.9792 10.1958 10.5875 10.5875C10.1958 10.9792 10 11.45 10 12C10 12.55 10.1958 13.0208 10.5875 13.4125C10.9792 13.8042 11.45 14 12 14Z"
                fill="#11151C"
              />
            </svg>
          }
          title="Usar localização atual"
          description={address}
        />
      </ButtonWrapper>
      <DividerHorizontal />
    </Section>
  );
};
